import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import { BLACK, BLUE050 } from '../../../theme';
import Button, {
  ButtonIconPosition,
  ButtonSize,
  ButtonVariant,
} from '../Button';
import Text, { TextKind } from '../Text';

const Banner = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  background: ${BLUE050};
  min-height: 30px;
`;

const TextWrapper = styled.span`
  display: flex;
  gap: 4px;

  margin-right: 24px;
  margin-left: 8px;
`;

interface AlertBannerProps {
  icon?: IconDefinition;
  primaryText?: React.ReactNode;
  secondaryText?: React.ReactNode;
  ctaText?: string;
  ctaOnClick?: () => void;
  ctaIcon?: React.ReactNode;
  ctaIconPosition?: ButtonIconPosition;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  icon,
  primaryText,
  secondaryText,
  ctaText,
  ctaOnClick,
  ctaIcon,
  ctaIconPosition,
}) => (
  <Banner data-testid="AlertBanner-Container">
    {icon && (
      <FontAwesomeIcon
        color={BLACK}
        icon={icon}
        fontSize={20}
        data-testid="alertIcon"
      />
    )}
    <TextWrapper>
      {primaryText && (
        <Text kind={TextKind.BodyM} bold>
          {primaryText}
        </Text>
      )}
      {secondaryText && <Text kind={TextKind.BodyM}>{secondaryText}</Text>}
    </TextWrapper>
    {ctaText && (
      <Button
        onClick={ctaOnClick}
        variant={ButtonVariant.Dark}
        size={ButtonSize.Small}
        icon={ctaIcon}
        iconPosition={ctaIconPosition}
      >
        {ctaText}
      </Button>
    )}
  </Banner>
);
